import {
    itMortgageBank,
} from '@/static/pages/constants/creditRates';

import MosPrimeSlideLogo from '@/assets/images/pages/for-individuals/mortgage/mosprime/mos-prime-mobile.png';

/**
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
*/
const itMortgageBankSlide = {
    slideImg: {
        src: 'profit-propositions/mortgage/mortgage4.png',
        alt: 'Ипотека для работников ИТ-сферы (условия банка)',
    },
    slideTitle: {
        title: 'Ипотека для работников ИТ-сферы (условия банка)',
        additionalClasses: ['profit-propositions-box__title it-mortgage'],
    },
    slideValue: {
        value: 'для работников ИТ-сферы <br> (условия банка)',
    },
    slideLink: '/for-individuals/mortgage/it-mortgage-bank',
    slideAddition: {
        prefix: 'от',
        rate: itMortgageBank.rate,
        postfix: 'годовых',
    },
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
 * core/models/pages/for-individuals/crediting/CreditingModel.js
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
 * core/models/pages/business-page/SelfemployedModel.js
*/
const mortgageAndRefinSlide = {
    slideImg: {
        src: 'profit-propositions/mortgage/mortgage5.webp',
        alt: 'Покупка недвижимости и рефинансирование ипотеки',
    },
    slideTitle: {
        title: 'Ипотека',
        additionalClasses: ['profit-propositions-box__title'],
    },
    slideValue: {
        value: 'Приобретение недвижимости и&nbsp;рефинансирование ипотеки стороннего банка',
    },
    slideLink: '/for-individuals/refinancing/mortgage-refinancing',
};

const mortgageProgrammBank = {
    slideImg: {
        src: 'profit-propositions/mortgage/mortgage5.webp',
        alt: 'Приобретение недвижимости на вторичном рынке',
    },
    slideTitle: {
        title: 'Ипотека',
        additionalClasses: ['profit-propositions-box__title'],
    },
    slideValue: {
        value: 'Приобретение недвижимости на вторичном рынке',
    },
    slideLink: '/for-individuals/mortgage/bank-programm',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
 * core/models/pages/for-individuals/crediting/CreditingModel.js
*/
const mortgageChildSlide = {
    slideImg: {
        src: 'profit-propositions/mortgage/mortgage2.webp',
        alt: 'Семейная ипотека',
    },
    slideTitle: {
        title: 'Семейная ипотека',
    },
    slideLink: '/for-individuals/mortgage/mortgage-children',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
 * core/models/pages/for-individuals/crediting/CreditingModel.js
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
 * core/models/pages/esg/EsgModel.js
*/
const itMortgageSlide = {
    slideImg: {
        src: 'profit-propositions/mortgage/it-mortgage.webp',
        alt: 'Ипотека для работников ИТ-сферы (госпрограмма)',
    },
    slideTitle: {
        title: 'Ипотека для работников ИТ-сферы (госпрограмма)',
        additionalClasses: ['profit-propositions-box__title it-mortgage'],
    },
    slideLink: '/for-individuals/mortgage/it-mortgage',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
 * core/models/pages/for-individuals/crediting/CreditingModel.js
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
*/
const mortgageVillageSlide = {
    slideImg: {
        src: 'profit-propositions/mortgage/village.webp',
        alt: 'Сельская ипотека',
    },
    slideTitle: {
        title: 'Сельская ипотека',
        additionalClasses: ['profit-propositions-box__title'],
    },
    slideValue: {
        value: 'Приобретение недвижимости<br/>на&nbsp;сельских территориях (агломерациях)',
    },
    slideLink: '/for-individuals/mortgage/village',
};

/**
 * core/models/pages/home-page/ProfitPropositionsModel.js
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
*/
const mortgagesSecondarySlide = {
    slideImg: {
        src: 'profit-propositions/mortgage/mortgage6.jpg',
        alt: 'Ипотека на вторичном рынке',
    },
    slideTitle: {
        title: 'Ипотека на вторичном рынке',
        additionalClasses: ['profit-propositions-box__title'],
    },
    slideValue: {
        value: 'В том числе земельный участок',
    },
    slideLink: '/for-individuals/refinancing/mortgage-refinancing',
};

/**
 * core/models/pages/for-individuals/crediting/CreditingModel.js
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
*/
const mortgageConstructionSlide = {
    slideImg: {
        src: 'components/mortgage/mortgage-building.png',
        alt: 'Ипотека на строительство',
    },
    slideTitle: {
        title: 'Ипотека на&nbsp;строительство',
    },
    slideLink: '/for-individuals/mortgage/building',

};

/**
 * core/models/pages/for-individuals/crediting/CreditingModel.js
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
*/
const mortgageCommercialSlide = {
    slideImg: {
        src: 'components/business-page/popular3.png',
        alt: 'Коммерческая недвижимость',
    },
    slideTitle: {
        title: 'Коммерческая недвижимость',
    },
    slideLink: '/for-individuals/mortgage/commercial-property',
};

/**
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
*/
const greenMortgageSlide = {
    slideImg: {
        src: 'pages/for-individuals/mortgage/green-mortgage-banner-small.png',
        alt: 'Зелёная ипотека',
    },
    slideTitle: {
        title: 'Зелёная ипотека',
        additionalClasses: ['profit-propositions-box__title', 'profit-propositions-box__title_with-after'],
    },
    slideValue: {
        value: 'на энергоэффективное жилье',
    },
    slideLink: '/for-individuals/mortgage/green-mortgage',
};

/**
 * core/models/pages/for-individuals/mortgage/MortgageModel.js
*/

const mosPrimeSlide = {
    slideImg: {
        src: 'pages/for-individuals/mortgage/mosprime/mos-prime-small-slide.webp',
        alt: 'Ипотека с MosPrime',
    },
    slideTitle: {
        title: `Ипотека с <br /> <img src="${MosPrimeSlideLogo}" alt="MosPrime" />`,
        additionalClasses: ['profit-propositions-box__title mosprime-mortgage'],
    },
    slideValue: {
        value: 'Индикативная ставка предоставления рублевых кредитов (депозитов) на московском денежном рынке',
    },
    slideLink: '/for-individuals/mortgage/mosprime',
};

const firstLoanMortgage = {
    slideImg: {
        src: 'slides/consumer-loan/first-credit-suggestion.webp',
        alt: 'Первый кредит',
    },
    slideTitle: {
        title: 'Первый кредит по&nbsp;сниженной ставке',
    },
    slideLink: '/for-individuals/refinancing/mortgage-refinancing#credit-calculator',
    target: '_self',
};

const largeFamilyMortgageSlide = {
    slideImg: {
        src: 'pages/for-individuals/mortgage/large-family-slide-small.jpg',
        alt: 'Ипотека для многодетной семьи',
    },
    slideTitle: {
        title: 'Ипотека для многодетной семьи',
    },
    slideLink: '/for-individuals/mortgage/large-family',
};

export {
    mortgageAndRefinSlide,
    mortgageProgrammBank,
    mortgageChildSlide,
    itMortgageSlide,
    mortgageVillageSlide,
    mortgagesSecondarySlide,
    mortgageConstructionSlide,
    mortgageCommercialSlide,
    greenMortgageSlide,
    mosPrimeSlide,
    firstLoanMortgage,
    itMortgageBankSlide,
    largeFamilyMortgageSlide,
};
